import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { form } from 'helpers/decorators'

import { Select, Checkbox } from 'components/fields'
import { Button } from 'components/misc'
import { Form } from 'components/layout'
import {
  localesByCodeDropdownSelector,
  localesLoadingSelector
} from 'redux/selectors/locales'
import { validate } from 'models/translation-messages'

const enhance = compose(
  connect(state => ({
    languages: localesByCodeDropdownSelector(state),
    loading: localesLoadingSelector(state)
  })),
  form({
    form: 'translations-management',
    validate
  })
)

class TranslationsManagement extends Component {
  static propTypes = {
    languages: PropTypes.array,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    loading: PropTypes.bool
  }

  render() {
    const { onSubmit, handleSubmit, languages, loading } = this.props

    return (
      <Form
        loading={loading}
        className="form"
        onSubmit={handleSubmit(fields => {
          onSubmit(fields)
        })}
      >
        <div className="row">
          <div className="col-xs-4 text--left">
            <Select
              name="language"
              labelless
              options={languages}
              hasFormGroup={false}
              placeholder="Select Language"
              intlKeyPlaceholder="placeholder.selectLanguage"
            />
          </div>
        </div>
        <div className="row base-margin--bottom" />
        <div className="form-group">
          <span className="control-label">
            <FormattedMessage
              className="control-label"
              id="translationsManagment.selectProject"
              defaultMessage="Select Project"
            />
          </span>
          <Checkbox
            label="Backend (emails, dropdowns, values)"
            intlKey="label.backend"
            name="projects.be"
          />
          <Checkbox
            label="Backoffice (Award Staff web static labels)"
            intlKey="label.backoffice"
            name="projects.bo"
          />
          <Checkbox
            className="reset--margin-bottom"
            label="Frontoffice (Participant web static labels)"
            intlKey="label.frontoffice"
            name="projects.fo"
          />

          <Checkbox
              className="reset--margin-bottom"
              label="User Engagement Backend (dropdowns, values, etc.)"
              intlKey="label.ue_be"
              name="projects.uebe"
          />
          <Checkbox
              className="reset--margin-bottom"
              label="User Engagement Frontend (Participant web static labels)"
              intlKey="label.ue_fe"
              name="projects.uefe"
          />
          <Checkbox
              className="reset--margin-bottom"
              label="Assessor Web Backend (dropdowns, values, etc.)"
              intlKey="label.aw_be"
              name="projects.awbe"
          />
          <Checkbox
              className="reset--margin-bottom"
              label="Assessor Web Frontend (Assessor web static labels)"
              intlKey="label.aw_fe"
              name="projects.awfe"
          />
          <Checkbox
              className="reset--margin-bottom"
              label="Customisable Emails (emails translations)"
              intlKey="label.ce_be"
              name="projects.cebe"
          />
          <Checkbox
              label="Documents (Translations for the labels used in the documents and the reports)"
              intlKey="label.doc"
              name="projects.doc"
          />
        </div>
        <div className="row">
          <div className="col-xs-12 text--left">
            <Button intlKey="button.updateSelectedLanguage">
              Update selected language
            </Button>
          </div>
        </div>
      </Form>
    )
  }
}

export default enhance(TranslationsManagement)
